<script lang="ts">
  /** Error card with retry — the counterpart of an empty state for failed
      loads, so API failures never masquerade as "no data". */
  import { _ } from "svelte-i18n";

  let { onretry }: { onretry: () => void } = $props();
</script>

<div class="empty-state card load-error" role="alert">
  <span class="material-icons-outlined empty-icon">cloud_off</span>
  <p>{$_("common.error")}</p>
  <button class="btn btn--secondary" onclick={onretry}>
    <span class="material-icons-outlined">refresh</span>
    {$_("common.retry")}
  </button>
</div>

<style>
  .load-error {
    text-align: center;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .load-error .empty-icon {
    font-size: 40px;
    color: var(--color-text-muted, #8a94a6);
  }
</style>
